import { DecoderWorker } from "../web-workers";
import { FrameToDecode } from "../web-workers/Decoder.worker";
import { Logger } from "./Logger";

export interface DecodeResult {
  dataUrl: string;
  height: number;
  width: number;
  decodeOffset: number;
}

export class DecoderPair {
  private canvas?: HTMLCanvasElement;
  private decoder: DecoderWorker;
  private decoderIsWorking: boolean;
  private height: number;
  private readonly uploadId: string;
  private isPaused: boolean;
  private readonly onPairResult: (result: DecodeResult) => void;
  private rotatedDecoder: DecoderWorker;
  private rotatedDecoderIsWorking: boolean;
  private width: number;
  private offsetTrack: number;

  constructor(onPairResult: (result: DecodeResult) => void, offsetTrack: number, uploadId: string) {
    this.decoder = new DecoderWorker();
    this.decoderIsWorking = false;
    this.decoder.onmessage = this.onDecodeResult.bind(this, false);
    this.uploadId = uploadId;
    this.isPaused = false;
    this.offsetTrack = offsetTrack;
    this.onPairResult = onPairResult;
    this.rotatedDecoder = new DecoderWorker();
    this.rotatedDecoderIsWorking = false;
    this.rotatedDecoder.onmessage = this.onDecodeResult.bind(this, true);
  }

  private onDecodeResult = (isRotated: boolean, event: any) => {
    Logger.infoWithId(
      this.uploadId,
      `Decoder with isRotated:${isRotated}, offsetTrack:${this.offsetTrack} ` +
      `got result:{offset:${event.data.decodeOffset}, result:${event.data.result}`,
    );
    if (isRotated) {
      this.rotatedDecoderIsWorking = false;
    } else {
      this.decoderIsWorking = false;
    }

    if (!this.isPaused && event.data.result === "SUCCESS" && !!this.canvas) {
      this.onPairResult ({
        dataUrl: this.canvas.toDataURL("image/png"),
        decodeOffset: event.data.decodeOffset,
        height: this.height,
        width: this.width,
      });
    }
    this.canvas = undefined;
  };

  public startDecode = (canvas: HTMLCanvasElement, context: CanvasRenderingContext2D,
                        height: number, width: number) => {
    if (this.isPaused || this.decoderIsWorking || this.rotatedDecoderIsWorking) {
      return;
    }

    this.canvas = canvas;
    this.decoderIsWorking = true;
    this.rotatedDecoderIsWorking = true;

    const data = context.getImageData(0, 0, width, height).data;

    const message: FrameToDecode = {
      data,
      height,
      offsetTrack: this.offsetTrack,
      rotate: false,
      width,
    };

    this.decoder.postMessage(message);
    this.rotatedDecoder.postMessage({
      ...message,
      rotate: true,
    });
  };

  public isReady = (): boolean => {
    return !this.decoderIsWorking && !this.rotatedDecoderIsWorking && !this.isPaused;
  };

  public setPaused = (isPaused: boolean) => {
    this.isPaused = isPaused;
  };

  public terminate = () => {
    this.decoder.terminate();
    this.rotatedDecoder.terminate();
  };
}



// WEBPACK FOOTER //
// ./src/constants/DecoderPair.ts